import css from "styled-jsx/css";

export const componentStyles = css`
  .manage-options-wrapper {
    display: flex;
    flex-direction: row;
    max-width: 800px;
    flex-wrap: wrap;
    justify-content: center;
  }
`;
